<div class="app-container">
	@if (myProfile != true) {
		<p-toolbar>
			<ng-template pTemplate="left">
				<div class="ml-toolbar" pTooltip="Back To External User List">
					<p-button label="Back To List" icon="pi pi-arrow-left" (onClick)="goBackToListPage()" />
				</div>
			</ng-template>
			<ng-template pTemplate="right" />
		</p-toolbar>
	}
	<p-tabs #tabs (valueChange)="tabOnChange($event)" [(value)]="activeTabValue">
		<p-tablist>
			<p-tab value="details">Details</p-tab>
			@if (myProfile != true && showActivity()) {
				<p-tab value="activity">Activity</p-tab>
			}
		</p-tablist>
		<p-tabpanels>
			<p-tabpanel value="details">
				@if (activeTabValue === 'details') {
					<app-external-user-profile-details
						#detail
						[item]="item"
						[formMode]="formMode"
						(detailsUpdated)="detailsUpdated($event)"
						(editCancelled)="editCancelled()" />
				}
			</p-tabpanel>
			<p-tabpanel value="activity">
				@if (activeTabValue === 'activity') {
					<app-audit-history #auditHistoryList [parentReferenceId]="item.UserProfileId" [parentReferenceTypeCode]="referenceTypeCode" />
				}
			</p-tabpanel>
		</p-tabpanels>
	</p-tabs>
</div>
